export const sortingOrder = {
  ASC: 'asc',
  DESC: 'dsc',
};

export type sortingOrderType = typeof sortingOrder[keyof typeof sortingOrder];

export const sortingAs = {
  DATE: 'DATE',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
};

export type SortingAsType = typeof sortingAs[keyof typeof sortingAs];
